"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TripHistoryModule = /** @class */ (function () {
    function TripHistoryModule() {
    }
    return TripHistoryModule;
}());
exports.TripHistoryModule = TripHistoryModule;
